import styled from 'styled-components';

export const PartyJackpotInGameWidgetClockContainerBox = styled.div`
    width: 100%;
    
    div {
        width: 100%;
        text-align: center;
        font-size: 26px;
        color: ${props => props.theme.colors.textLight};

        @media ${(props) => props.theme.mediaQuery.xlExact} {
            font-size: 21px;
        }

        @media ${props => props.theme.mediaQuery.lAndBelow} {
            font-size: 13px;
        }
    }
`;
